(() => {
  'use strict';
  const endpoint = document.querySelector('meta[name="dearore-promo-checkout-url"]')?.content?.trim();
  const dialog = document.querySelector('[data-dearore-delivery-dialog]');
  if (!endpoint || !(dialog instanceof HTMLDialogElement)) return;
  const pickupUrl = new URL(endpoint, window.location.origin);
  pickupUrl.pathname = pickupUrl.pathname.replace(/\/promo-checkout\/?$/, '/pickup-points');
  pickupUrl.search = '';
  pickupUrl.hash = '';
  const pickupEndpoint = pickupUrl.toString();
  const AREA_ORDER = ['香港島', '九龍', '新界', '其他地區'];
  const TYPE_ORDER = ['Post Office', 'iPostal Station', '7-Eleven'];
  const TYPE_LABEL = { 'Post Office': '郵局', 'iPostal Station': '智郵站', '7-Eleven': '7-Eleven' };
  const state = { busy: false, points: [], resolve: null, loadingPoints: null };
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];
  const fields = {
    form: $('[data-dearore-delivery-form]', dialog), country: $('[data-dearore-country]', dialog),
    hk: $('[data-dearore-hk-panel]', dialog), overseas: $('[data-dearore-overseas-panel]', dialog),
    name: $('[data-dearore-recipient-name]', dialog), phone: $('[data-dearore-recipient-phone]', dialog),
    email: $('[data-dearore-recipient-email]', dialog), area: $('[data-dearore-pickup-area]', dialog),
    district: $('[data-dearore-pickup-district]', dialog), type: $('[data-dearore-pickup-type]', dialog),
    search: $('[data-dearore-pickup-search]', dialog),
    pickup: $('[data-dearore-pickup]', dialog), selected: $('[data-dearore-selected-point]', dialog),
    retry: $('[data-dearore-pickup-retry]', dialog), sevenNote: $('[data-dearore-seven-note]', dialog),
    sourceNote: $('[data-dearore-pickup-source-note]', dialog),
    ack: $('[data-dearore-ack]', dialog), error: $('[data-dearore-delivery-error]', dialog),
  };

  function setBusy(busy) {
    state.busy = busy;
    $$('button[name="checkout"], .cart__checkout-button').forEach((button) => {
      if (!(button instanceof HTMLButtonElement)) return;
      const text = button.querySelector('.button-text');
      if (!button.dataset.dearoreText) button.dataset.dearoreText = text?.textContent || button.textContent || '';
      if (text) text.textContent = busy ? '正在準備結帳…' : button.dataset.dearoreText;
      button.disabled = busy; button.toggleAttribute('aria-busy', busy);
    });
  }

  function savedDelivery() {
    try { return JSON.parse(sessionStorage.getItem('dearoreDelivery') || 'null'); } catch { return null; }
  }
  function pickupConfig() {
    return window.DEARORE_PICKUP_CONFIG && typeof window.DEARORE_PICKUP_CONFIG === 'object'
      ? window.DEARORE_PICKUP_CONFIG : {};
  }
  function canonicalType(type) {
    const value = String(type || '').trim();
    if (/^(郵局|post office)$/i.test(value)) return 'Post Office';
    if (/^(智郵站|智提點|ipostal station)$/i.test(value)) return 'iPostal Station';
    if (/^(7-?eleven|7-11|便利店)$/i.test(value)) return '7-Eleven';
    return value;
  }
  function embeddedPoints() {
    const source = window.DEARORE_PICKUP_SNAPSHOT?.points;
    if (!Array.isArray(source) || !source.length) return [];
    const byCode = new Map(source.map((point) => [String(point.code), { ...point }]));
    const overrides = Array.isArray(window.DEARORE_PICKUP_OVERRIDES) ? window.DEARORE_PICKUP_OVERRIDES : [];
    if (pickupConfig().overridesEnabled !== false) {
      overrides.forEach((override) => {
        const code = String(override?.code || '').trim();
        if (!code || override?.enabled === false) return;
        const action = String(override.action || 'update').trim().toLowerCase();
        if (action === 'hide' || action === 'delete' || action === 'remove') {
          byCode.delete(code);
          return;
        }
        const previous = byCode.get(code) || {};
        const merged = { ...previous, code };
        for (const key of ['name', 'address', 'district', 'area']) {
          if (String(override[key] || '').trim()) merged[key] = String(override[key]).trim();
        }
        const type = canonicalType(override.type);
        if (type) merged.type = type;
        if (merged.name && merged.address && merged.area && merged.type) byCode.set(code, merged);
      });
    }
    const config = pickupConfig();
    return [...byCode.values()].filter((point) => {
      if (config.areas && config.areas[point.area] === false) return false;
      if (config.types && config.types[point.type] === false) return false;
      return true;
    }).sort((a, b) => [a.area, a.type, a.district, a.name, a.address]
      .join('|').localeCompare([b.area, b.type, b.district, b.name, b.address].join('|'), 'zh-HK'));
  }
  function showError(message = '') { fields.error.textContent = message; fields.error.hidden = !message; }
  function pickupLoadError(error) {
    if (error?.name === 'AbortError') return '載入自提點逾時，請重試。';
    if (error instanceof TypeError) return '網絡暫時未能連接自提點服務，請按「重新載入自提點」。';
    return error?.message || '暫時未能載入自提點，請重試。';
  }
  function selectedPoint() { return state.points.find((point) => point.code === fields.pickup.value) || null; }
  function districtName(point) { return String(point?.district || '').trim() || '其他／未分類'; }
  function sortByPreferredOrder(values, preferred) {
    return values.sort((a, b) => {
      const ai = preferred.indexOf(a); const bi = preferred.indexOf(b);
      if (ai !== -1 || bi !== -1) return (ai === -1 ? preferred.length : ai) - (bi === -1 ? preferred.length : bi);
      return a.localeCompare(b, 'zh-HK');
    });
  }
  function shortAddress(address, max = 72) {
    const value = String(address || '').replace(/\s+/g, ' ').trim();
    return value.length > max ? `${value.slice(0, max - 1)}…` : value;
  }
  function renderSummary(delivery = savedDelivery()) {
    $$('[data-dearore-delivery-summary-text]').forEach((node) => {
      const text = delivery?.pickup ? `${TYPE_LABEL[delivery.pickup.type] || delivery.pickup.type}｜${delivery.pickup.name}｜${delivery.pickup.address}｜${delivery.recipient.name} ${delivery.recipient.phone}` : '結帳前請選擇香港郵政易寄取自提點';
      if (node.textContent !== text) node.textContent = text;
    });
  }

  function renderAreas() {
    const available = sortByPreferredOrder([...new Set(state.points.map((point) => point.area).filter(Boolean))], AREA_ORDER);
    fields.area.replaceChildren(new Option('請選擇地區', ''));
    available.forEach((area) => fields.area.add(new Option(area, area)));
    fields.area.disabled = false;
  }

  function renderDistricts() {
    const current = fields.district.value;
    const districts = [...new Set(state.points
      .filter((point) => point.area === fields.area.value)
      .map(districtName))].sort((a, b) => a.localeCompare(b, 'zh-HK'));
    fields.district.replaceChildren(new Option(fields.area.value ? '請選擇分區' : '請先選擇地區', ''));
    districts.forEach((district) => fields.district.add(new Option(district, district)));
    fields.district.disabled = !fields.area.value;
    if (districts.includes(current)) fields.district.value = current;
    renderTypes();
  }

  function renderTypes() {
    const current = fields.type.value;
    const types = sortByPreferredOrder([...new Set(state.points
      .filter((point) => point.area === fields.area.value && districtName(point) === fields.district.value)
      .map((point) => point.type))], TYPE_ORDER);
    fields.type.replaceChildren(new Option(fields.district.value ? '請選擇自提點類別' : '請先選擇分區', ''));
    types.forEach((type) => fields.type.add(new Option(TYPE_LABEL[type] || type, type)));
    fields.type.disabled = !fields.district.value;
    if (types.includes(current)) fields.type.value = current;
    renderPoints(fields.search.value);
  }

  function renderPoints(filter = '') {
    const current = fields.pickup.value;
    const needle = filter.trim().toLocaleLowerCase('zh-HK');
    const ready = Boolean(fields.area.value && fields.district.value && fields.type.value);
    const visible = state.points.filter((point) => point.area === fields.area.value
      && districtName(point) === fields.district.value && point.type === fields.type.value
      && (!needle || [point.code, point.name, point.address, point.district, point.type].join(' ').toLocaleLowerCase('zh-HK').includes(needle)));
    const prompt = ready ? (visible.length ? '請選擇具體自提點' : '沒有符合的自提點') : '請先選擇地區、分區及類別';
    fields.pickup.replaceChildren(new Option(prompt, ''));
    visible.forEach((point) => fields.pickup.add(new Option(`【${point.code}】${point.name}｜${shortAddress(point.address)}`, point.code)));
    if (visible.some((point) => point.code === current)) fields.pickup.value = current;
    fields.pickup.disabled = !ready;
    fields.search.disabled = !ready;
    fields.sevenNote.hidden = fields.type.value !== '7-Eleven';
  }

  async function loadPoints(force = false) {
    if (!force && state.points.length) return;
    const builtIn = embeddedPoints();
    if (builtIn.length) {
      state.points = builtIn;
      renderAreas();
      fields.retry.hidden = true;
      if (fields.sourceNote) {
        const updated = window.DEARORE_PICKUP_SNAPSHOT?.updated_at;
        const date = updated ? new Date(updated).toLocaleDateString('zh-HK') : '';
        fields.sourceNote.textContent = `使用內置清單${date ? `（更新：${date}）` : ''}，共 ${builtIn.length} 個地點；不需連接外部網站。`;
      }
      return;
    }
    if (state.loadingPoints) return state.loadingPoints;
    fields.pickup.replaceChildren(new Option('正在載入香港郵政資料…', ''));
    fields.area.disabled = true; fields.district.disabled = true; fields.type.disabled = true; fields.pickup.disabled = true; fields.search.disabled = true;
    fields.retry.hidden = true;
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 20_000);
    state.loadingPoints = (async () => {
      const response = await fetch(pickupEndpoint, {
        headers: { Accept: 'application/json' },
        credentials: 'omit',
        cache: 'no-store',
        signal: controller.signal,
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok || !Array.isArray(data.points) || !data.points.length) {
        throw new Error(data.message || `暫時未能載入自提點（${response.status}），請重試。`);
      }
      state.points = data.points;
      renderAreas();
      if (fields.sourceNote) fields.sourceNote.textContent = `使用後備網絡清單，共 ${state.points.length} 個地點。`;
    })();
    try {
      await state.loadingPoints;
    } finally {
      window.clearTimeout(timeout);
      state.loadingPoints = null;
    }
  }

  function restoreSelection(saved) {
    const point = saved?.pickup?.code ? state.points.find((item) => item.code === saved.pickup.code) : null;
    if (!point) return;
    fields.area.value = point.area || '';
    renderDistricts();
    fields.district.value = districtName(point);
    renderTypes();
    fields.type.value = point.type || '';
    renderPoints();
    fields.pickup.value = point.code;
    fields.pickup.dispatchEvent(new Event('change'));
  }

  function setCountry() {
    const hk = fields.country.value === 'HK';
    fields.hk.hidden = !hk; fields.overseas.hidden = hk;
  }

  async function openDialog() {
    const saved = savedDelivery();
    if (saved) { fields.name.value = saved.recipient?.name || ''; fields.phone.value = saved.recipient?.phone || ''; fields.email.value = saved.recipient?.email || ''; fields.ack.checked = true; }
    fields.country.value = 'HK'; setCountry(); showError(); dialog.showModal();
    try {
      await loadPoints();
      restoreSelection(saved);
    } catch (error) {
      showError(pickupLoadError(error));
      fields.pickup.replaceChildren(new Option('載入失敗，請按下方重新載入', ''));
      fields.retry.hidden = false;
    }
    return new Promise((resolve) => { state.resolve = resolve; });
  }

  function closeDialog(result = null) { if (dialog.open) dialog.close(); state.resolve?.(result); state.resolve = null; }
  fields.country.addEventListener('change', setCountry);
  fields.area.addEventListener('change', () => { fields.district.value = ''; fields.type.value = ''; fields.search.value = ''; fields.selected.hidden = true; renderDistricts(); });
  fields.district.addEventListener('change', () => { fields.type.value = ''; fields.search.value = ''; fields.selected.hidden = true; renderTypes(); });
  fields.type.addEventListener('change', () => { fields.search.value = ''; fields.selected.hidden = true; renderPoints(); });
  fields.search.addEventListener('input', () => renderPoints(fields.search.value));
  fields.retry.addEventListener('click', async () => {
    showError();
    fields.retry.hidden = true;
    try {
      await loadPoints(true);
      restoreSelection(savedDelivery());
    } catch (error) {
      showError(pickupLoadError(error));
      fields.pickup.replaceChildren(new Option('載入失敗，請按下方重新載入', ''));
      fields.retry.hidden = false;
    }
  });
  fields.pickup.addEventListener('change', () => {
    const point = selectedPoint(); fields.selected.hidden = !point;
    fields.selected.replaceChildren();
    if (!point) return;
    const details = document.createElement('div');
    details.textContent = `${TYPE_LABEL[point.type] || point.type}｜${point.area}｜${districtName(point)}\n地點編號：${point.code}\n${point.name}\n${point.address}`;
    const copy = document.createElement('button');
    copy.type = 'button'; copy.className = 'dearore-delivery-dialog__selected-copy'; copy.textContent = '複製地點編號';
    copy.addEventListener('click', async () => {
      try { await navigator.clipboard.writeText(point.code); copy.textContent = '已複製'; }
      catch { copy.textContent = `地點編號：${point.code}`; }
    });
    fields.selected.append(details, copy);
  });
  $$('[data-dearore-delivery-close]', dialog).forEach((button) => button.addEventListener('click', () => closeDialog(null)));
  document.addEventListener('click', (event) => { if (event.target.closest('[data-dearore-open-delivery]')) { event.preventDefault(); openDialog(); } });

  fields.form.addEventListener('submit', (event) => {
    event.preventDefault(); showError();
    if (fields.country.value !== 'HK') { showError('非香港訂單必須先聯絡客服，暫不能直接結帳。'); return; }
    const phone = fields.phone.value.replace(/[\s()-]/g, '');
    const point = selectedPoint();
    if (!fields.name.value.trim()) return showError('請填寫收件人姓名。');
    if (!/^(?:\+?852)?[456789]\d{7}$/.test(phone)) return showError('請填寫可接收 SMS 的正確香港手機號碼。');
    if (!point) return showError('請選擇香港郵政易寄取自提點。');
    if (!fields.ack.checked) return showError('請先確認收件及付款提示。');
    const delivery = { delivery_country: 'HK', delivery_acknowledged: true, recipient: { name: fields.name.value.trim(), phone, email: fields.email.value.trim() }, pickup: point };
    sessionStorage.setItem('dearoreDelivery', JSON.stringify(delivery)); renderSummary(delivery); closeDialog(delivery);
  });

  async function loadCart() {
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { credentials: 'same-origin', headers: { Accept: 'application/json' }, cache: 'no-store' });
    if (!response.ok) throw new Error('未能讀取購物車，請重新整理。');
    return response.json();
  }
  function payload(cart, delivery) {
    return { cart_token: cart.token || '', currency: cart.currency || 'HKD', note: cart.note || '', ...delivery,
      lines: (cart.items || []).map((item) => ({ variant_id: item.variant_id, quantity: item.quantity, properties: item.properties || {}, selling_plan_id: item.selling_plan_allocation?.selling_plan?.id || null })) };
  }
  async function checkout(cart, delivery) {
    const response = await fetch(endpoint, { method: 'POST', credentials: 'omit', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload(cart, delivery)) });
    const data = await response.json().catch(() => ({}));
    if (response.ok && data.checkout_url) return data.checkout_url;
    throw new Error(data.message || '結帳暫時未能建立，請稍後再試。');
  }
  document.addEventListener('submit', async (event) => {
    const form = event.target; const button = event.submitter;
    if (!(form instanceof HTMLFormElement) || form.id !== 'cart-form' || (button && button.name !== 'checkout' && !button.classList.contains('cart__checkout-button'))) return;
    event.preventDefault(); if (state.busy) return;
    let delivery = savedDelivery();
    if (!delivery) delivery = await openDialog();
    if (!delivery) return;
    setBusy(true);
    try { window.location.assign(await checkout(await loadCart(), delivery)); }
    catch (error) { console.error('[DearOre Checkout]', error); window.alert(error.message); setBusy(false); }
  }, true);

  renderSummary();
  new MutationObserver(() => renderSummary()).observe(document.documentElement, { childList: true, subtree: true });
})();
